export default {
	sec_01: {
		title: {
			one: '온라인 및',
			two: '대면 결제',
			three: ' 수락',
		},
		btn: {
			one: '회원가입하기',
			two: '영업팀에 문의',
		},
	},
	sec_14: {
		btn: '시작하려면 계정 전문가에게 문의하세요. ',
	},
	sec_03: {
		title: {
			one: '경쟁 우위를 확보',
		},
		desc: {
			one: '우리는 소기업이 거의 모든 곳에서 지불을 받을 수 있도록 돕습니다.',
		},
		one: {
			title: {
				one: '고객이 요구하는',
				two: '유연성',
			},
			desc: {
				one: '고객이 나중에 결제하거나, 구독에 등록하거나,',
				two: '글로벌 또는 로컬 결제 옵션을 사용하도록 하세요.',
			},
		},
		two: {
			title: {
				one: '전 세계 구매자와 연결',
			},
			desc: {
				one: '모든 암호화폐로 온라인 또는 매장에서',
				two: '결제를 수락합니다.',
			},
		},
		three: {
			title: {
				one: '온라인 결제',
				two: '수락',
			},
			desc: {
				one: '고객이 원하는 방식으로 결제하고 빠르게',
				two: '결제 할 수 있도록 하세요. 여기 에서 온라인으로',
				three: '지불을 수락하는 방법에 대해 자세히 알아보세요.',
			},
		},
	},
	sec_15: {
		title: {
			one: 'Introducing the benefits of JP WORLD Pay.',
		},
		cards: {
			one: {
				title: {
					one: '온라인 체크아웃',
				},
				description: {
					one: '고객은 단일 솔루션으로 사이트, ',
					two: '모바일 또는 앱에서 다양한 ',
					three: '결제 수단을 사용 할 수 있습니다.',
				},
				btn_01: {
					one: '온라인 체크아웃에',
					two: '대한 추가 정보',
				},
				btn_02: {
					one: '구독 서비스에',
					two: '대한 추가 정보',
				},
			},
			two: {
				title: {
					one: '송장 및 견적',
				},
				description: {
					one: '고객이 쉽게 지불 할 수 있는',
					two: '맞춤형 무료 인보이스를 보내어',
					three: '지불을 독려 할 수 있습니다.',
				},
				btn: {
					one: '인보이스 발행에 ',
					two: '대한 추가 정보',
				},
			},
			three: {
				title: {
					one: '소셜에서 판매',
				},
				description: {
					one: '다양한 소셜 미디어 플랫폼에서',
					two: '저희 JP WORLD PAY 결제 시스템을 ',
					three: '이용하여 결제를 받으십시오.',
				},
				btn: {
					one: '소셜에서 판매하기에 대해 ',
					two: '자세히 알아보기',
				},
			},
			four: {
				title: {
					one: '온라인 암호화폐',
					two: '결제 시스템',
				},
				description: {
					one: '당사의 신용 및 온라인 결제 서비스를 통해 대부분의',
					two: '주요 암호화폐를 통해',
					three: '온라인 및 매장 내 결제를 수락 할 수 있습니다.',
				},
			},
			five: {
				title: {
					one: '직접 지불 수락',
				},
				description: {
					one: '고객이 직접 쇼핑하는 동안 비용을 지불하게 하십시오.',
					two: '여기에서 작동 방식을 알아보세요.',
				},
			},
			six: {
				title: {
					one: '판매 시점',
				},
				description: {
					one: '모든 인기있는 결제 유형을 수락하고',
					two: '판매를 추적하며 완벽한',
					three: 'POS 솔루션인 JP WORLD PAY Setting',
					four: '비즈니스를 관리하세요.',
				},
				btn: {
					one: 'JP WORLD PAY Setting에 대해 ',
					two: '자세히 알아보기',
				},
			},
		},
	},
	common: {
		coming_soon: '준비중 입니다.',
	},
};
